import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __MMOS_GA_INITIALIZED__?: boolean;
  }
}

function initializeAnalytics(measurementId: string) {
  if (window.__MMOS_GA_INITIALIZED__) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };

  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false,
    anonymize_ip: true,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  window.__MMOS_GA_INITIALIZED__ = true;
}

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID) return;

    initializeAnalytics(GA_ID);
  }, []);

  useEffect(() => {
    if (!GA_ID || !window.gtag) return;

    window.gtag('event', 'page_view', {
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
